module.exports = __webpack_public_path__ + "static/media/AnimationsBad.07467568.mov";